export enum UserDocumentUploadTypeType {
  BUG_REPORT = 'BUG_REPORT',
}

export enum FileCategory {
  IMAGE = 'image',
  DOCUMENT = 'document',
}

export interface UploadInfo {
  fileCategory: FileCategory;
  upload: File;
  uri: string;
}

export interface DocumentUpload {
  id: string;
  fileNameWithoutExt: string;

  fileExt: string;

  fileName: string;

  key: string;

  isDeleted: boolean;

  mimeType: string;

  createdAt: string;

  isImage: boolean;

  isDocument: boolean;
}

export type EdgeType<T> = {
  node: T;
  __typename: string;
};

export interface DocumentUploadType {
  id: string;
  logID: string | null;
  fileName: string;
  fileSize: number | null;
  url: string;
  uploadType: UserDocumentUploadTypeType | null;
  mimeType: string | null;
  isDeleted: boolean;
  createdAt: string;
}
export interface CreateDocumentUploadData {
  createUserDocumentUpload: {
    userDocumentUploadEdge: EdgeType<DocumentUploadType>;
  };
}

export interface UploadFileType {
  filePath: string;
  fileName: string;
  mimeType: string | undefined;
}
